// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
._record_main {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  cursor: default;
}
._record_main ._record_t {
  width: 209px;
  height: 209px;
}
@media (max-width: 576px) {
  ._record_main ._record_t {
    width: auto;
    height: 180px;
  }
}
._record_main ._record_level_t {
  position: absolute;
  bottom: 8px;
}
._record_main ._record_level_t ._record_xt {
  width: 73px;
}
._record_main ._record_level_t ._record_xt:not(:first-child) {
  margin-left: -46px;
}

._nft_data_box {
  padding: 0 6px;
  justify-content: space-between;
}
._nft_data_box .nft_img {
  width: 45px;
  height: 45px;
  border-radius: 3px;
  object-fit: cover;
}
._nft_data_box ._nft_title {
  border-radius: 3px;
  height: 45px;
  width: 145px;
  background: #171515;
  display: flex;
  justify-content: center;
}
._nft_data_box ._nft_title p {
  padding-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/SongNft/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AAvBA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAyBJ;AAtBI;EACI,YAAA;EACA,aAAA;AAwBR;ADFE;ECxBE;IAQQ,WAAA;IACA,aAAA;EAsBV;AACF;AAlBI;EACI,kBAAA;EACA,WAAA;AAoBR;AAjBQ;EACI,WAAA;AAmBZ;AAhBY;EACI,kBAAA;AAkBhB;;AATA;EACI,cAAA;EACA,8BAAA;AAYJ;AATI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAWR;AAPI;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AASR;AANQ;EACI,iBAAA;AAQZ","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"../../styles/mixins\";\n\n\n\n\n._record_main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: relative;\n    cursor: default;\n\n\n    ._record_t {\n        width: 209px;\n        height: 209px;\n\n\n\n\n        @include sm {\n            width: auto;\n            height: 180px;\n        }\n    }\n\n\n    ._record_level_t {\n        position: absolute;\n        bottom: 8px;\n\n\n        ._record_xt {\n            width: 73px;\n\n\n            &:not(:first-child) {\n                margin-left: -46px;\n            }\n\n\n        }\n    }\n}\n\n\n._nft_data_box {\n    padding: 0 6px;\n    justify-content: space-between;\n\n\n    .nft_img {\n        width: 45px;\n        height: 45px;\n        border-radius: 3px;\n        object-fit: cover;\n    }\n\n\n    ._nft_title {\n        border-radius: 3px;\n        height: 45px;\n        width: 145px;\n        background: #171515;\n        display: flex;\n        justify-content: center;\n\n\n        p {\n            padding-left: 6px\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
